module.exports = __webpack_public_path__ + "static/media/1eshospital.a98ac2c4.png";